import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantName, selectUserName } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { PurchaseAcceptancePrintBody } from '../../../models/PurchaseAcceptancePrint'
import { PrintBody } from '../../../models/recentTimeDrugCollectionEfforts'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './recentTimeDrugCollectionEfforts.module.css'
import {
  getRDCEffortsExportAsync,
  getRDCEffortsListAsync,
} from './recentTimeDrugCollectionEffortsSlice'

export const RecentTimeDrugCollectionEffortList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const theme = useContext(ThemeContext)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [printData, setPrintData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [exportLoading, setExportLoading] = useState<any>(false)

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
    day: 180,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getRDCEffortsListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '6') {
      if (!queries.current) return
      getDataList()
      getPrintDataList()
    }
  }, [queries, props?.selectKey])

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getRDCEffortsExportAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '近效期药品催销表.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const getPrintDataList = () => {
    setPageLoading(true)
    dispatch(getRDCEffortsListAsync({ ...queries, current: 1, size: 10000 }))
      .then(unwrapResult)
      .then((res: any) => {
        setPrintData(res.records)
      })
      .finally(() => setPageLoading(false))
  }

  const dataMainList = {
    tenantName: tenantName?.split('-')?.[0],
    userName: userName,
    dataList: printData,
  }

  const content = PrintBody(dataMainList)

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          exportLoading={exportLoading}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
          }}
          export={() => {
            exportExcel()
          }}
          print={() => {
            const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
            page.document.write(content) // 写入打印页面的内容
            page.print() // 打印
            page?.close()
          }}
        />
        <EditableList
          rowKey={(v, i) => `${i}`}
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
    </Col>
  )
}
